import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { Fragment, memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import Form from './form';

interface AccordionResidenceProps {
  idFamilyAnpr?: string;
  codeEnte?: string;
  yearId?: string;
  typeRegister?: string;
  progressive?: string;
  typePractice?: string;
  ForPracticeTemporary?: boolean;
  disabled?: boolean;
  iniziativa?: string;
  intestatarioIsAnpr?: boolean;
  fromPerson?: string;
}

const AccordionResidenceComponent = ({
  idFamilyAnpr,
  codeEnte,
  yearId,
  typeRegister,
  progressive,
  ForPracticeTemporary,
  typePractice,
  disabled,
  iniziativa,
  intestatarioIsAnpr = false,
  fromPerson,
}: AccordionResidenceProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-new-residence-content"
          id="panel-new-residence-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>
            {ForPracticeTemporary ? 'Residenza Temporanea' : 'Nuova residenza'}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Form
            ForPracticeTemporary={ForPracticeTemporary}
            idFamilyAnpr={idFamilyAnpr}
            codeEnte={codeEnte}
            yearId={yearId}
            typeRegister={typeRegister}
            intestatarioIsAnpr={intestatarioIsAnpr}
            progressive={progressive}
            typePractice={typePractice}
            fromPerson={fromPerson}
            disabled={disabled}
            iniziativa={iniziativa}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionResidenceComponent.displayName = 'Accordion Residence';

const AccordionResidence = memo(AccordionResidenceComponent);

export default AccordionResidence;
